package pnemonic.balloon_pop.view

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.keepScreenOn
import androidx.navigation.compose.rememberNavController
import pnemonic.balloon_pop.view.navigation.NavigationGraph

@Composable
fun MainScreen() {
    val navController = rememberNavController()

    Box(modifier = Modifier.fillMaxSize().keepScreenOn()) {
        NavigationGraph(navController = navController)
    }
}